import Layout from '../components/layout/Layout';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-secondary py-12" data-testid="privacy-policy-page">
        <div className="max-w-4xl mx-auto px-4">
          <Card>
            <CardHeader>
              <CardTitle className="font-serif text-3xl">Datenschutzerklärung / Privacy Policy</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <h2>1. Verantwortlicher</h2>
              <p>
                Die vollständigen Angaben zum Verantwortlichen finden Sie in unserem{' '}
                <Link to="/impressum" className="text-primary hover:underline">Impressum</Link>.<br />
                Email: privacy@wedvaya.com
              </p>

              <h2>2. Erhobene Daten</h2>
              <p>Wir erheben folgende personenbezogene Daten:</p>
              <ul>
                <li>Name und E-Mail-Adresse bei der Registrierung</li>
                <li>Profilinformationen (Bio, Interessen)</li>
                <li>Zahlungsdaten werden von Stripe verarbeitet</li>
                <li>Kommunikationsdaten zwischen Nutzern</li>
                <li>Nutzungsstatistiken und technische Daten</li>
              </ul>

              <h2>3. Zweck der Datenverarbeitung</h2>
              <p>Ihre Daten werden verarbeitet für:</p>
              <ul>
                <li>Bereitstellung der Plattform-Dienste</li>
                <li>Vermittlung zwischen Gastgebern und Gästen</li>
                <li>Zahlungsabwicklung</li>
                <li>Kundensupport</li>
                <li>Verbesserung unserer Dienste</li>
              </ul>

              <h2>4. Rechtsgrundlage</h2>
              <p>
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
                (Vertragserfüllung) und Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
              </p>

              <h2>5. Datenweitergabe</h2>
              <p>Ihre Daten werden an folgende Dritte weitergegeben:</p>
              <ul>
                <li>Stripe für Zahlungsabwicklung</li>
                <li>Cloud-Hosting-Anbieter für die Infrastruktur</li>
                <li>Andere Nutzer im Rahmen der Plattform-Funktionen</li>
              </ul>

              <h2>6. Ihre Rechte</h2>
              <p>Sie haben das Recht auf:</p>
              <ul>
                <li>Auskunft über Ihre gespeicherten Daten</li>
                <li>Berichtigung unrichtiger Daten</li>
                <li>Löschung Ihrer Daten</li>
                <li>Einschränkung der Verarbeitung</li>
                <li>Datenübertragbarkeit</li>
                <li>Widerruf Ihrer Einwilligung</li>
              </ul>

              <h2>7. Speicherdauer</h2>
              <p>
                Ihre Daten werden gespeichert, solange Ihr Konto aktiv ist. Nach Löschung des 
                Kontos werden personenbezogene Daten innerhalb von 30 Tagen gelöscht, sofern 
                keine gesetzlichen Aufbewahrungspflichten bestehen.
              </p>

              <h2>8. Cookies</h2>
              <p>
                Wir verwenden technisch notwendige Cookies für die Funktionalität der Plattform. 
                Analyse-Cookies werden nur mit Ihrer Einwilligung gesetzt.
              </p>

              <h2>9. Kontakt</h2>
              <p>
                Bei Fragen zum Datenschutz wenden Sie sich bitte an:<br />
                privacy@wedvaya.com
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                Stand: Oktober 2026
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
